<script setup>
defineProps({
    icon: {
        type: Object,
        required: true, // { path, viewbox }
    },
    size: {
        type: [String, Number],
        default: 24,
    },
})
</script>

<template>
    <svg :width="size" :height="size" :viewBox="icon.viewbox" class="bee-icon">
        <path :d="icon.path" fill-rule="evenodd" />
    </svg>
</template>

<style scoped lang="scss">
.bee-icon path {
    fill: currentColor;
}
</style>